'use strict';

var _ = require('lodash');
var SsiUrlService = function SsiUrlService($filter, configurationService, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function buildSsiUrl(selectedRow, ssiUrl) {
    var constructedUrl = ssiUrl,
      poses = configurationService.getPoses(),
      segments,
      segElements;

    //Build prefix
    constructedUrl += '?carrier=' + selectedRow.carrier + '&page=Inventory_Analyzer';
    segments = selectedRow.serviceId.split('|');
    function parseSegmentCarrier(segElements, segmentIndex) {
      return '&cr' + segmentIndex + '=' + segElements.carrier;
    }
    function parseSegmentFlightNumber(segElements, segmentIndex) {
      return '&flt' + segmentIndex + '=' + segElements.flightNumber;
    }
    function parseSegmentDeparture(segElements, segmentIndex) {
      //comes in as '2015-05-01'
      var segDate = momentService.of(segElements.departure, momentService.FIELD.DEPARTURE_DATE, momentService.FORMAT.DATE_ISO);
      segDate = rmMomentFormat(segDate, 'DATE_ISO_REVERSE_NAMED_MONTH');
      return '&dt' + segmentIndex + '=' + segDate.toUpperCase();
    }
    function parseSegmentBoard(segElements, segmentIndex) {
      return '&brd' + segmentIndex + '=' + segElements.board;
    }
    function parseSegmentOff(segElements, segmentIndex) {
      return '&off' + segmentIndex + '=' + segElements.off;
    }
    function parseSegmentElements(segmentStr) {
      var elementsArr = segmentStr.split('.');
      return {
        carrier: elementsArr[1],
        flightNumber: elementsArr[2].split('[')[0],
        departure: elementsArr[2].split('[')[1].slice(0, -1),
        board: elementsArr[0],
        off: elementsArr[3]
      };
    }
    for (var i = 0; i < segments.length; i++) {
      segElements = parseSegmentElements(segments[i]);
      constructedUrl += parseSegmentCarrier(segElements, i) + parseSegmentFlightNumber(segElements, i) + parseSegmentDeparture(segElements, i) + parseSegmentBoard(segElements, i) + parseSegmentOff(segElements, i);
    }

    //Append suffix
    //map from the city we have to the correct config pos and then pull city/country from that
    poses = _.filter(poses, function (element) {
      if (element.origin === selectedRow.origin) {
        if (element.destination === selectedRow.destination) {
          return true;
        }
      }
      return false;
    });
    if (poses.length > 0) {
      if (!_.isNil(poses[0].country)) {
        constructedUrl += '&poscntr=' + poses[0].country;
      }
      if (!_.isNil(poses[0].city)) {
        constructedUrl += '&poscity=' + poses[0].city;
      }
    }
    return constructedUrl;
  }
  return {
    buildSsiUrl: buildSsiUrl
  };
};
SsiUrlService.$inject = ['$filter', 'ConfigurationService', 'MomentService'];
module.exports = SsiUrlService;